import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { orgActions, ingestionActions } from "../../actions";
import { IngestorNav } from "./IngestorNav";
import { Link } from "react-router-dom";

function DispatchRequest(props) {
  const [submitted, setSubmitted] = useState(false);
  const [ingestionRequest, setIngestionRequest] = useState({ limit: -1 });

  const { authentication, org, getOcrInfo, dispatch_ocr } = props;

  const user_orgs = authentication.user.orgs;
  const current_org_id = Number(org.current_org_id);
  const current_org_name = user_orgs.filter(
    (org) => org.org_id === current_org_id
  )[0].display_name;

  const ocr_info = org.ocr_info;

  useEffect(() => {
    getOcrInfo(current_org_id);
  }, [current_org_id]);

  const setScrapeLimit = (e) => {
    const { value } = e.target;
    ingestionRequest["limit"] = Number(value);
    console.log(ingestionRequest);
  };

  const setUseAws = (e) => {
    ingestionRequest["use_aws"] = e.target.checked;
    console.log(ingestionRequest);
  };

  const setUseAzure = (e) => {
    ingestionRequest["use_azure"] = e.target.checked;
    console.log(ingestionRequest);
  };

  const submitRequest = (e) => {
    e.preventDefault();
    ingestionRequest["org_id"] = current_org_id;
    ingestionRequest["org_name"] = current_org_name;
    ingestionRequest["ingestion_type"] = "dispatch";
    console.log(ingestionRequest);
    dispatch_ocr(ingestionRequest);
    setSubmitted(true);
  };

  return (
    <>
      {submitted && (
        <>
          <div class="refresh" />
          <div class="searchMain">
            <div class="contentContainerLeftNav">
              <div class="leftNav">
                <IngestorNav />
              </div>
              <div class="rightContent">
                <form class="ingestorForm">
                  <table class="ingestorFormTable">
                    <tr>
                      <td class="formLabel">&nbsp;</td>
                      <td class="formInfo">
                        <strong>Dispatch request initiated:</strong>
                      </td>
                    </tr>
                    <tr>
                      <td class="formLabel">Org:</td>
                      <td class="formInfo">{ingestionRequest.org_name}</td>
                    </tr>
                    <tr>
                      <td class="formLabel">File Limit:</td>
                      <td class="formInfo">{ingestionRequest.limit}</td>
                    </tr>
                    <tr>
                      <td class="formLabel">Use AWS:</td>
                      <td class="formInfo">
                        {ingestionRequest.use_aws ? "true" : "false"}
                      </td>
                    </tr>
                    <tr>
                      <td class="formLabel">Use Azure:</td>
                      <td class="formInfo">
                        {ingestionRequest.use_azure ? "true" : "false"}
                      </td>
                    </tr>
                    <tr>
                      <td class="formLabel">&nbsp;</td>
                      <td class="formInfo">
                        <Link to={"/org/" + current_org_id + "/ingestion"}>
                          go back
                        </Link>
                      </td>
                    </tr>
                  </table>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {!submitted && (
        <>
          <div class="refresh" />
          <div class="searchMain">
            <div class="contentContainerLeftNav">
              <div class="leftNav">
                <IngestorNav parent="dispatch" />
              </div>
              <div class="rightContent">
                <form class="ingestorForm">
                  <table class="ingestorFormTable">
                    <tr>
                      <td class="formLabel">Org:</td>
                      <td class="formInfo">{current_org_name}</td>
                    </tr>
                    <tr>
                      <td class="formLabel">Total pages:</td>
                      <td class="formInfo">{ocr_info?.total_pages}</td>
                    </tr>
                    <tr>
                      <td class="formLabel">Pages with AWS OCR complete:</td>
                      <td class="formInfo">{ocr_info?.aws_pages}</td>
                    </tr>
                    <tr>
                      <td class="formLabel">Pages with Azure OCR complete:</td>
                      <td class="formInfo">{ocr_info?.azure_pages}</td>
                    </tr>
                    <tr>
                      <td class="formLabel">Pages with Azure OCR pending:</td>
                      <td class="formInfo">{ocr_info?.azure_pending_pages}</td>
                    </tr>
                    <tr>
                      <td class="formLabel">
                        Pages not yet dispatched for OCR:
                      </td>
                      <td class="formInfo">{ocr_info?.undispatched_pages}</td>
                    </tr>
                    {ocr_info?.undispatched_pages > 0 && (
                      <>
                        <tr>
                          <td>&nbsp;</td>
                          <td class="errormessage formInfo">
                            There are {ocr_info?.undispatched_pages} pages not
                            yet dispatched for OCR.
                          </td>
                        </tr>
                        <tr colspan="2">
                          <td>&nbsp;</td>
                        </tr>
                        <tr>
                          <td colspan="2">&nbsp;</td>
                        </tr>
                        <tr>
                          <td>&nbsp;</td>
                          <td class="formInfo">Initiate a Dispatch Run:</td>
                        </tr>
                        <tr>
                          <td class="formLabel">
                            <label for="limit">Limit:</label>
                          </td>
                          <td class="formInfo">
                            <input
                              type="text"
                              name="limit"
                              id="limit"
                              onChange={setScrapeLimit}
                            ></input>
                          </td>
                        </tr>
                        <tr>
                          <td class="formLabel">
                            <label for="use_aws">Use AWS:</label>
                          </td>
                          <td class="formInfo">
                            <input
                              type="checkbox"
                              name="use_aws"
                              id="use_aws"
                              onClick={setUseAws}
                            ></input>
                          </td>
                        </tr>
                        <tr>
                          <td class="formLabel">
                            <label for="use_azure">Use Azure</label>
                          </td>
                          <td class="formInfo">
                            <input
                              type="checkbox"
                              name="use_azure"
                              id="limit"
                              onClick={setUseAzure}
                            ></input>
                          </td>
                        </tr>
                        <tr>
                          <td class="formLabel">&nbsp;</td>
                          <td class="formInfo">
                            <button class="submit" onClick={submitRequest}>
                              Submit
                            </button>
                          </td>
                        </tr>
                      </>
                    )}
                  </table>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getOcrInfo: orgActions.getOcrInfo,
  dispatch_ocr: ingestionActions.dispatch_ocr,
};

const connectedDispatchRequest = connect(
  mapStateToProps,
  actionCreators
)(DispatchRequest);
export { connectedDispatchRequest as DispatchRequest };
